import { apiGet } from "./apiClient";
import { apiPatch } from "./apiClient";
import { apiPost } from "./apiClient";

export function getInstitutionWallets(institutionId) {
    return apiGet(`/institutions/${institutionId}/wallets`);
}

export function getInstitutions() {
    return apiGet("/institutions/all");
}

export function getInstitution(institutionId) {
    return apiGet(`/institutions/${institutionId}`);
}

export async function getInstitutionManage(institutionId) {
  return apiGet(`/institutions/${institutionId}/manage`);
}

export async function getInstitutionExceptAccounts(institutionId) {
  return apiGet(`/institutions/accounts/except/${institutionId}`);
}

export async function getInstitutionManageAll() {
  return apiGet(`/institutions/manage-all`);
}

export async function getInstitutionHead() {
  return apiGet(`/institutions/main`);
}

export async function search({ query, searchType, valueType, from, to }) {
  const params = new URLSearchParams();

  if (!searchType) {
    throw new Error("searchType is required");
  }

  if (!valueType) {
    throw new Error("valueType is required");
  }

  if (!query?.trim()) {
    throw new Error("query is required");
  }

  params.append("searchType", searchType);
  params.append("valueType", valueType);
  params.append("query", query.trim());

  if (from) params.append("from", from);
  if (to) params.append("to", to);

  return apiGet(`/search-statements?${params.toString()}`);
}

// export async function getInstitutionIncomings(
//   receiverInstitutionId,
//   senderInstitutionId = 14,
//   startDate,
//   endDate
// ) {
//   const params = new URLSearchParams({
//     senderInstitutionId: String(senderInstitutionId),
//   });

//   if (startDate) {
//     params.append("startDate", startDate);
//   }

//   if (endDate) {
//     params.append("endDate", endDate);
//   }

//   return apiGet(
//     `/institutions/${receiverInstitutionId}/incoming-from-institution?${params.toString()}`
//   );
// }

export async function getInstitutionIncomings(
  receiverInstitutionId,
  startDate,
  endDate
) {
  const params = new URLSearchParams();

  if (startDate) {
    params.append("startDate", startDate);
  }

  if (endDate) {
    params.append("endDate", endDate);
  }

  const query = params.toString();

  return apiGet(
    `/institutions/${receiverInstitutionId}/incoming-from-all-institution${query ? `?${query}` : ""}`
  );
}

export async function getInstitutionIncomeSummary(
  institutionId,
  startDate,
  endDate
) {
  const params = new URLSearchParams();

  if (startDate) {
    params.append("startDate", startDate);
  }

  if (endDate) {
    params.append("endDate", endDate);
  }

  const query = params.toString();

  return apiGet(
    `/institutions/${institutionId}/statement-income-summary${
      query ? `?${query}` : ""
    }`
  );
}

export async function getInstitutionExpenseSummary(
  institutionId,
  startDate,
  endDate
) {
  const params = new URLSearchParams();

  if (startDate) {
    params.append("startDate", startDate);
  }

  if (endDate) {
    params.append("endDate", endDate);
  }

  const query = params.toString();

  return apiGet(
    `/institutions/${institutionId}/statement-expense-summary${
      query ? `?${query}` : ""
    }`
  );
}

export async function activateInstitution(institutionId) {
  return apiPatch(`/institutions/activate/${institutionId}`);
}

export async function deactivateInstitution(institutionId) {
  return apiPatch(`/institutions/deactivate/${institutionId}`);
}

export async function createInstitution(payload) {
  const response = await apiPost("/institutions", payload);
  return response.data;
}

export async function getCurrencies() {
  return apiGet(`/currencies`);
}

// InstitutionWalletsPage.js
export async function getInstitutionDashboardData(institutionId) {
  return apiGet(`/dashboard/institutions/${institutionId}/wallet-dashboard/weekly`);
}